/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Helmet from 'react-helmet';
import Sidebar from '../../components/SidebarBlogue';
import s from './categorieBlogue.css';
import HeightMatchingGroup from 'react-height-matching-group';
import { Link } from 'react-router';


@withStyles(s)
export default class categorieBlogue extends Component {

    constructor(props) {
        super(props);

        this.state = {
            posts: [],
            postsCategorie: [],
            url: '',
            slug: '',
            loader: true,
        };

        this.FilterPosts = this.FilterPosts.bind(this);
        
    }

    componentDidMount() {

        this.GetPosts();

    }

    componentWillReceiveProps(){
        
       this.GetPosts();

    }

    FilterPosts(items){

        this.setState({ 
            url: this.props.location.pathname,
            slug: this.props.location.pathname.split("/").slice(-1).pop(), 
        })

        var filtered = [];

        for(var i = 0; i < items.length; i++){

            var cat = items[i].categories

            for(var i2 = 0; i2 < cat.length; i2++){

                if(cat[i2].slug === this.state.slug){

                    filtered.push(items[i])
                    
                }
            }
        }

        return filtered;
    
    }

    async GetPosts() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{posts{id, slug, title, titlePost, content, excerpt, thumbnail, categories{id, slug, name}, date, authorName, authorAvatar}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.posts) throw new Error('Erreur sur le chargement des posts !');

        if(data){
            this.setState({ loader: false })
        }

        this.setState({ posts: data.posts })

        var postsCategorie = this.FilterPosts(this.state.posts)

        this.setState({ postsCategorie: postsCategorie });

    }

    render() {
        
        const appear = this.state.loader ? 'appear' : '';
        var background = {
            backgroundColor: '#ff8a00'
        }

        const title = 'Blogue';

        return (
            <div className={s.root}>
                <Helmet title={title} />
                <div className={`spinner ${appear}`} style={background} ></div>
                <div id="blogue" className={`blogue`}>
                    <div className={`bgHeader`}></div>
                    <main role="main">
                        <div className={`container`}>
                            <h1 className={`titrePage`}>{title}</h1>
                            <div className={`col-md-8`}>
                               <div className={`wrapArticles`}>
                                    <div className={`articles`}>
                                        <HeightMatchingGroup tagName="ul" selector=".match">
                                        {this.state.postsCategorie.slice(0, 1).map((item, index) => (
                                            <li key={index} className={`boxArticle`}>
                                                <div className={`content`}>
                                                    <div className={`thumbBlogue`}>
                                                        <Link to={`/blogue/${item.slug}`}>
                                                            <img src={item.thumbnail} alt="Image article" />
                                                        </Link>
                                                        <div className={`wrapCatArticle`}>
                                                            {item.categories.map((cat, index) => (
                                                                <span key={index} className={`catArticle`}>
                                                                    <Link to={`/blogue/categorie/${cat.slug}`}>{cat.name}</Link>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <span className={`titreArticle`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                                    </Link>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <div className={`excerptArticle`}>
                                                            <p>{item.excerpt}</p>
                                                            <span className={`lireSuite`}>Lire la suite ...</span>
                                                        </div>
                                                    </Link>
                                                    <div className={`auteurArticle`}>
                                                        <div className={`thumbAuteur`}>
                                                            <div dangerouslySetInnerHTML={{ __html: item.authorAvatar }} />
                                                        </div>
                                                        <span className={`nomAuteur`}>{item.authorName}</span>
                                                        <span className={`dateArticle`}>{item.date}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                        {this.state.postsCategorie.slice(1).map((item, index) => (
                                            <li key={index} className={`boxArticle match`}>
                                                <div className={`content`}>
                                                    <div className={`thumbBlogue`}>
                                                        <Link to={`/blogue/${item.slug}`}>
                                                            <img src={item.thumbnail} alt="Image article" />
                                                        </Link>
                                                        <div className={`wrapCatArticle`}>
                                                        {item.categories.map((cat, index) => (
                                                            <span key={index} className={`catArticle`}>
                                                                <Link to={`/blogue/categorie/${cat.slug}`}>{cat.name}</Link>
                                                            </span>
                                                        ))}
                                                        </div>
                                                    </div>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <span className={`titreArticle`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                                    </Link>
                                                    <Link to={`/blogue/${item.slug}`}>
                                                        <div className={`excerptArticle`}>
                                                            <p>{item.excerpt}</p>
                                                            <span className={`lireSuite`}>Lire la suite ...</span>
                                                        </div>
                                                    </Link>
                                                    <div className={`auteurArticle`}>
                                                        <div className={`thumbAuteur`}>
                                                            <div dangerouslySetInnerHTML={{ __html: item.authorAvatar }} />
                                                        </div>
                                                        <span className={`nomAuteur`}>{item.authorName}</span>
                                                        <span className={`dateArticle`}>{item.date}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                        </HeightMatchingGroup>
                                    </div>
                                </div>
                            </div>
                            <div className={`col-md-4`}>
                                <div className={`sidebar`}>
                                    <div className={`content`}>
                                        <Sidebar />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/categorieBlogue/categorieBlogue.js